import React from 'react';


export default class Pernas extends React.Component{
  constructor(props) {
    super(props);

    this.state = {

    };

  }

  render(){
    const strings = this.state.strings;

    return(
      <div>
        <strong>Por que treinar pernas 2 vezes na semana?</strong><br /><br />
        O Foco 90 é calculado da melhor forma para dar o melhor resultado para as MULHERES. O que as mulheres desejam é desenvolver mais perna/glúteo. Muitas chegam até mim dizendo que queriam treinar pernas 3x por semana porque quer desenvolver mais esse grupamento, mas esquecem que tenho experiência de mais de 20 anos em musculação feminina para dizer que treinar pernas 3x por semana é exatamente o que não vai te dar resultado.<br /><br />
        A ciência mostra que o ideal de descanso muscular para treinos de ER (Exercícios Resistidos=Musculação ) é de aproximadamente 72h a 96h de DESCANSO. Isso significa treinar cada grupamento 2 vezes por semana.<br /><br />
        Por isso, Quando Criei a Metodologia do Foco90, calculei Todos os treinos... eu disse todos, quer você escolha hipertrofia ou emagrecimento; quer você treine 3, 4, 5 ou 6 X por semana, você terá sempre 2 treinos semanais para cada grupamento e sempre um intervalo de 72h até 96 de descanso para cada grupamento.<br /><br />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/classes/tecnicas/Pernas.js